module.exports = __webpack_public_path__ + "img/btnactionicon.e73ecca4.svg";